import { Grid, Skeleton, useBreakpointValue } from '@chakra-ui/react';
import {
  LEADERBOARD_ROW_COLUMNS,
  LEADERBOARD_ROW_COLUMNS_COMPACT,
  LEADERBOARD_ROW_MIN_H,
  LEADERBOARD_ROW_PX,
  LEADERBOARD_ROW_PY,
} from './LeaderboardRow';

export function LeaderboardSkeletonRow() {
  const columns = useBreakpointValue({
    base: LEADERBOARD_ROW_COLUMNS_COMPACT,
    sm: LEADERBOARD_ROW_COLUMNS,
  }) ?? LEADERBOARD_ROW_COLUMNS_COMPACT;
  const rowPx = useBreakpointValue({ base: 2, sm: LEADERBOARD_ROW_PX }) ?? 2;

  return (
    <Grid
      templateColumns={columns}
      columnGap={2}
      alignItems='center'
      py={LEADERBOARD_ROW_PY}
      px={rowPx}
      borderRadius='md'
      background='listItemBackground'
      minH={LEADERBOARD_ROW_MIN_H}
      w='full'
    >
      <Skeleton h='4' w='7' borderRadius='sm' />
      <Skeleton h='3' w='3' borderRadius='full' />
      <Skeleton h='4' flex={1} maxW='60%' borderRadius='sm' />
      <Skeleton h='4' w='12' borderRadius='sm' justifySelf='end' />
      <Skeleton h='4' w='6' borderRadius='sm' justifySelf='end' />
    </Grid>
  );
}
